import AuthService from "../domain/AuthService";
import ErrorHandler from "../error/ErrorHandler";
import LinksProvider from "../http/LinksProvider";
import SavedActionsService from "../utils/SavedActionsService";
import { ToastProvider, useToasts } from "react-toast-notifications";
import React, { useEffect, useState } from "react";
import { withTranslation } from "../../i18n";
import WithGA from "./withGa";
import cookies from "next-cookies";
import CookiesBanner from "../../shared/cookies/cookies-banner/CookiesBanner";
import Router from "next/router";

const redirect = (ctx, url) => {
  typeof window !== "undefined"
    ? Router.push(url)
    : ctx.res.writeHead(302, { Location: url }).end();
};

export const withPageWrapper = ({
  authenticated,
  namespacesRequired,
  hasAccess,
  allCookies,
} = {}) => {
  return (WrappedComponent) => {
    const Wrapper = (props) => {
      const { addToast } = useToasts();
      const [isAnalyticCookiesActive] = useState(null);

      useEffect(() => {
        // Get messages from cookies on client side
        const errorMessages = ErrorHandler.getCookieErrorMessages();
        const successMessages = ErrorHandler.getCookieSuccessMessages();

        ErrorHandler.displayCookieErrorMessages(
          errorMessages,
          addToast,
          props.t
        );
        ErrorHandler.displayCookieSuccessMessages(
          successMessages,
          addToast,
          props.t
        );
      }, [addToast, props.t]);

      return (
        <React.Fragment>
          <WithGA
            isAnalyticCookiesActive={isAnalyticCookiesActive}
            content={<WrappedComponent {...props} />}
          />

          <CookiesBanner />
        </React.Fragment>
      );
    };

    // getInitialProps removed - pages now use getServerSideProps directly

    return withTranslation(namespacesRequired)(Wrapper);
  };
};
